export default () => {
  return {
    dark: true,
    primaryColor: 'light-blue darken-3',
    forgotLinkColor: {hex: '#0277BD'},
    profileBGImage: '/static/generic-profile.png',
    bannerImage: 'https://storage.googleapis.com/cp-conduit-storage/themes/default/background-triangles.svg',
    logoLogin: 'https://storage.googleapis.com/cp-conduit-storage/themes/default/CPConduit-Primary-Logo.svg', // blue word logo
    logoMainMinimized: 'https://storage.googleapis.com/cp-conduit-storage/themes/default/CP-Secondary-Logo-Icon-Blue.png', // The small icon logo
    logoMainExpanded: 'https://storage.googleapis.com/cp-conduit-storage/themes/default/CPConduit-Logo.svg', // white word logo
    logoMainCurrent: 'https://storage.googleapis.com/cp-conduit-storage/themes/default/CPConduit-Logo.svg',
    logoHeight: 72,
    loginStart: {hex: '#007995'},
    loginEnd: {hex: '#032341'},
    logoContrast: true,
    logoContrastType: 'light'
  }
}

/*
        dark: true,
        primaryColor: 'red accent-4',
        forgotLinkColor: {hex: '#d50000'},
        profileBGImage: '/static/spinach-profile.png',
        bannerImage: '/static/salad-banner.png',
        logoImage: '/static/og-logo.svg',
        logoHeight: 138,
        loginStart: {hex: '#176fb2'},
        loginEnd: {hex: '#003f6c'},
        logoContrast: false,
        logoContrastType: 'dark',
 */
